import localhost from "../../../apis/localhost";
import { showErrorModal } from "../../app/actions/error";
import { addToJobQueue, removeFromJobQueue } from "../../app/appSlice";
import {
  setSharepointConnectionsTested,
  setSharepointLoading,
} from "../sharepointSlice";
import {
  CONNETION_FAILED,
  TEST_JOB,
  TEST_POLL_INTERVAL,
  TEST_POPUP_BLOCKED,
  TEST_SIGN_IN_CLOSED,
  TEST_TIMED_OUT,
} from "./constants";

const finishTest = (dispatch, failureMessage) => {
  dispatch(setSharepointLoading(false));
  dispatch(removeFromJobQueue(TEST_JOB));
  if (failureMessage) {
    dispatch(showErrorModal({ message: failureMessage }, CONNETION_FAILED));
  }
};

const isTestCompleted = async (isCloudMode) => {
  try {
    const rsp = await localhost.get(
      isCloudMode ? "/sharepoint/cloud/check" : "/sharepoint/check"
    );
    return rsp.status === 200;
  } catch (error) {
    return false;
  }
};

const reportTestSuccess = async (dispatch, isCloudMode) => {
  await localhost.post(
    isCloudMode ? "/sharepoint/cloud/success" : "/sharepoint/success"
  );
  dispatch(setSharepointConnectionsTested(true));
};

const checkTestAuthentication = (
  authWindow,
  isCloudMode,
  dispatch,
  timeoutDuration = 120000
) =>
  new Promise((resolve) => {
    const startTime = Date.now();
    const finish = (tested, failureMessage) => {
      finishTest(dispatch, failureMessage);
      resolve(tested);
    };
    const poll = async () => {
      if (await isTestCompleted(isCloudMode)) {
        if (!authWindow.closed) {
          authWindow.close();
        }
        await reportTestSuccess(dispatch, isCloudMode);
        finish(true);
        return;
      }
      if (authWindow.closed) {
        finish(false, TEST_SIGN_IN_CLOSED);
        return;
      }
      if (Date.now() - startTime >= timeoutDuration) {
        finish(false, TEST_TIMED_OUT);
        return;
      }
      setTimeout(poll, TEST_POLL_INTERVAL);
    };
    poll();
  });

export const testSharepointSettings = ({ settings, isCloudMode }) => {
  const {
    sharepointUrl,
    sharepointEnabled,
    clientId,
    tenantId,
    clientSecret,
    siteUrl,
  } = settings;
  const params = {
    sharepointUrl,
    sharepointEnabled,
    clientId,
    tenantId,
    clientSecret,
    siteUrl,
    redirectUrl: window.location.href,
  };

  const url = isCloudMode ? "/sharepoint/cloud/test" : "/sharepoint/test";

  return async (dispatch) => {
    dispatch(addToJobQueue(TEST_JOB));
    let data;
    try {
      ({ data } = await localhost.post(url, params));
    } catch (error) {
      dispatch(removeFromJobQueue(TEST_JOB));
      dispatch(showErrorModal(error, CONNETION_FAILED));
      return false;
    }
    if (!data?.url) {
      dispatch(removeFromJobQueue(TEST_JOB));
      return false;
    }
    dispatch(setSharepointLoading(true));
    const authWindow = window.open(data.url, "_blank");
    if (!authWindow) {
      finishTest(dispatch, TEST_POPUP_BLOCKED);
      return false;
    }
    return checkTestAuthentication(authWindow, isCloudMode, dispatch);
  };
};
